<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaEventParticipants"
        title-table="Participantes do Evento"
        module="eventParticipantSettingsModule"
        sort-name="registro.nome"
        add-permission="ROLE_EVENTOS_INSERIR"
        view-permission="ROLE_EVENTOS_CONSULTAR"
        edit-permission="ROLE_EVENTOS_ATUALIZAR"
        delete-permission="ROLE_EVENTOS_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <EventParticipantForm
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import EventParticipantForm from './form/EventParticipantForm.vue'

export default {
  name: 'EventParticipantSetting',
  components: {
    BRow,
    BCol,
    TableComponents,
    EventParticipantForm,
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'ID',
          field: 'id',
          width: '80px',
        },
        {
          label: 'Evento',
          field: 'evento.nome',
        },
        {
          label: 'Participante',
          field: 'registro.nome',
        },
        {
          label: 'Inscrito em',
          field: 'inscritoEm',
          formatter: value => {
            if (!value) return '-'
            const date = new Date(value)
            return date.toLocaleString('pt-BR')
          },
        },
        {
          label: 'Action',
          field: 'action',
          width: '80px',
        },
      ],
    }
  },
  computed: {
    ...mapState('eventParticipantSettingsModule', {
      listaEventParticipants: state => state.listaEventParticipants,
    }),
  },
  methods: {
    addNew() {
      this.$store.dispatch('eventParticipantSettingsModule/reset')
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch(
        'eventParticipantSettingsModule/prepareToEdit',
        data,
      )
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
      this.$store.dispatch('eventParticipantSettingsModule/reset')
    },
  },
}
</script>
